<template>
  <div class="schedule-section mt-2">
    <div class="px-2">
      <p class="schedule-section-title">Customer Details</p>
    </div>
    <div class="customer-card">
      <div class="customer-row">
        <div class="customer-avatar">
          <v-avatar size="40">
            <v-img
              v-if="customerInfo?.avatar"
              :src="customerInfo.avatar"
              :alt="customerInfo.name || 'Customer avatar'"
              cover
            />
            <v-icon v-else size="18">mdi-account</v-icon>
          </v-avatar>
        </div>
        <div class="customer-copy">
          <p class="customer-name">{{ customerInfo?.name || "-" }}</p>
          <p class="customer-meta">
            <v-icon size="14">mdi-phone-outline</v-icon>
            <span>{{ customerInfo?.phone_no || "-" }}</span>
          </p>
          <p class="customer-meta">
            <v-icon size="14">mdi-email-outline</v-icon>
            <span>{{ customerInfo?.email || "-" }}</span>
          </p>
        </div>
      </div>

      <div class="summary-actions">
        <a
          class="summary-action"
          :class="{ 'summary-action--disabled': !customerEmailHref }"
          :href="customerEmailHref || undefined"
        >
          <v-icon size="18" color="deep-orange-darken-1">mdi-email-outline</v-icon>
          <span>Email</span>
        </a>
        <a
          class="summary-action summary-action--split"
          :class="{ 'summary-action--disabled': !customerPhoneHref }"
          :href="customerPhoneHref || undefined"
        >
          <v-icon size="18" color="deep-orange-darken-1">mdi-phone-outline</v-icon>
          <span>Call</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  customerInfo?: {
    avatar: string | null;
    name: string | null;
    phone_no: string | null;
    email: string | null;
  } | null;
}>();

const customerEmailHref = computed(() => {
  const email = props.customerInfo?.email?.trim();
  return email ? `mailto:${email}` : "";
});

const customerPhoneHref = computed(() => {
  const phone = props.customerInfo?.phone_no?.trim();
  return phone ? `tel:${phone}` : "";
});
</script>

<style scoped>
.schedule-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.schedule-section-title {
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: #6b7280;
}

.customer-card {
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.customer-row {
  display: flex;
  gap: 12px;
  padding: 12px 14px;
  align-items: center;
}

.customer-avatar {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  overflow: hidden;
  background: rgba(249, 115, 22, 0.12);
  color: #f97316;
  flex-shrink: 0;
  display: grid;
  place-items: center;
}

.customer-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.customer-name {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.customer-meta {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: var(--color-subtitle-light);
}

.summary-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid #e5e7eb;
}

.summary-action {
  min-height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  background: #fff;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  text-decoration: none;
}

.summary-action--split {
  border-left: 1px solid #e5e7eb;
}

.summary-action--disabled {
  pointer-events: none;
  opacity: 0.45;
}
</style>
